import cn from 'classnames'

import { Image } from '@lib/components'

import { getAvatarColor, getEmptyAvatar } from './helpers'
import styles from './styles.module.scss'
import { AvatarProps } from './types'

export const Avatar = ({
  size = 'small',
  avatar = '',
  fullName = '',
  template = 'user-sm',
}: AvatarProps) => {
  const avatarColor = getAvatarColor(fullName)
  const emptyAvatar = getEmptyAvatar(fullName)

  const isLogoTemplate = template === 'logo-sm' || template === 'logo-md'
  const avatarClassName = cn(styles.avatar, styles[size], {
    [styles.logo]: isLogoTemplate,
  })
  const avatarStyle = { backgroundColor: avatarColor }

  return avatar ? (
    <Image
      url={avatar}
      alt={fullName}
      className={avatarClassName}
      template={template}
    />
  ) : (
    <div className={avatarClassName} style={avatarStyle}>
      {emptyAvatar}
    </div>
  )
}
